import { Pipe, PipeTransform } from '@angular/core';

import { Observable, of } from 'rxjs';
import { UnitConversionService } from '../services/unit-conversion.service';

@Pipe({
  name: 'unitConversion',
  pure: true,
  standalone: false,
})
export class UnitConversionPipe implements PipeTransform {
  constructor(private unitConversionService: UnitConversionService) {}
  transform(value: number, baseUnit: string, targetUnit: string, valueType: string): Observable<number> {
    if (!value || !baseUnit || !targetUnit || !valueType) {
      return of(value);
    }

    return this.unitConversionService.convert(value, baseUnit, targetUnit, valueType);
  }
}
